import axiosInstance from './axios.instance';

/**
 * Handle API errors consistently
 * Returns error response or creates a standardized error object for network errors
 */
const handleApiError = (err) => {
  if (err.response) {
    // Server responded with error status
    return err.response;
  }
  // Network error or request setup error - create consistent error object
  return {
    status: 500,
    data: null,
    message: err.message || 'Network error occurred'
  };
};

export const API_GET_ALL_ANNOUNCEMENTS = async () => {
  try {
    return await axiosInstance.get(`/announcements`);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_GET_ALL_TEAMS_ANNOUNCEMENTS = async () => {
  try {
    return await axiosInstance.get(`/announcements/teams`);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_GET_ASSIGNED_ANNOUNCEMENT = async () => {
  try {
    return await axiosInstance.get(`/announcement/assigned`);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_GET_ANNOUNCEMENT = async (id) => {
  try {
    return await axiosInstance.get(`/announcement/${id}`);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_GET_THUMBNAIL_UPLOAD_URL = async (id) => {
  try {
    return await axiosInstance.get(`/announcement/thumbnail/uploadUrl/${id}`);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_CREATE_ANNOUNCEMENT = async () => {
  try {
    return await axiosInstance.post(`/announcement`);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_UPDATE_ANNOUNCEMENT = async (id, body) => {
  try {
    return await axiosInstance.put(`/announcement/${id}`, body);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_CLONE_ANNOUNCEMENT = async (id) => {
  try {
    return await axiosInstance.post(`/announcement/${id}/clone`);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_DELETE_ANNOUNCEMENT = async (id) => {
  try {
    return await axiosInstance.delete(`/announcement/${id}`);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_UNPUBLISH_ANNOUNCEMENT = async (id) => {
  try {
    return await axiosInstance.post(`/announcement/${id}/unpublish`);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_UPDATE_ANNOUNCEMENT_TEAMS = async (id, body) => {
  try {
    return await axiosInstance.put(`/announcement/${id}/teams`, body);
  } catch (err) {
    return handleApiError(err);
  }
};

export const API_BULK_DELETE_ANNOUNCEMENTS = async (announcementIds) => {
  try {
    return await axiosInstance.delete(`/announcements`, { data: { announcementIds } });
  } catch (err) {
    return handleApiError(err);
  }
};
